import { DateTime } from "luxon";

export const normalizeISO = dt => {
  const norm = DateTime.fromISO(dt);
  return norm.toLocaleString(DateTime.DATETIME_MED);
};

export const relativeISO = dt => {
  const norm = DateTime.fromISO(dt);
  return norm.toRelative();
}

export default {
  normalizeISO,
  relativeISO
};
